import { isBrowser } from "../../../utils/ssr";

export function getSourceOrigin() {
  const queryParams = new URLSearchParams((isBrowser() && window?.location.search) || "");
  return queryParams.get("source") || null;
}
